import { Cancel, Clear } from '@mui/icons-material';
import { Box, Grid, IconButton, ListItemText, MenuItem, Stack, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import {
  WsColors,
  Item,
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
  SearchBar,
  WsButton,
} from 'wisestep-base';

const TemplateItem = styled(MenuItem)(({ theme }) => ({
  padding: theme.spacing(2),
  minWidth: '15vw',
  '.Mui-selected': {
    backgroundColor: WsColors.TheBlues50,
  },
  ':hover': {
    backgroundColor: WsColors.TheBlues50,
  },
}));

const TemplateIndexContainer = styled(Item)(() => ({
  padding: 0,
  overflow: 'auto',
  borderRight: '1px solid' + WsColors.TertiaryShades100,
}));

interface ITemplateItemTextProps {
  selected: boolean;
}

const TemplateItemText = styled(ListItemText)(({ selected }: ITemplateItemTextProps) => ({
  color: selected ? WsColors.TheBlues500 : WsColors.GenericRichBlack,
}));

export interface ITemplateListingProps<T> {
  templates: T[];
  handleClose: () => void;
  getTemplateId: (arg: string) => void;
  width?: string;
}

interface ITemplateResponse {
  id?: string;
  subject?: string;
  body?: string;
  name?: string;
  createdBy?: string;
}
// interface previewTemplateType {
//   subject: string;
//   body: string;
// }
const TemplateListing = <T extends ITemplateResponse>({
  templates,
  handleClose,
  getTemplateId,
}: ITemplateListingProps<T>) => {
  const methods = useForm();
  const [filteredTemplateList, setFilteredTemplateList] = useState<T[]>(templates);
  // const [selected, setSelected] = useState<number>(0);
  const [selected, setSelected] = useState<T>(templates[0]);
  // const [previewTemplate, setPreview] = useState<previewTemplateType>({
  //   subject: templates[0]?.subject ?? '',
  //   body: templates[0]?.body ?? '',
  // });

  const importTemplate = () => {
    // getTemplateId(templates[selected].id ?? '');
    handleClose();
    getTemplateId(selected?.id ?? '');
  };

  const searchTemplates = methods.watch('templatesFilter') ?? '';

  useEffect(() => {
    if (searchTemplates) {
      const filteredRows =
        templates?.filter((row) => {
          return (
            row?.name?.toLowerCase().includes(searchTemplates.toLowerCase()) ||
            row?.createdBy?.toLocaleLowerCase().includes(searchTemplates.toLowerCase())
          );
        }) ?? [];
      setFilteredTemplateList(filteredRows);
    } else {
      setFilteredTemplateList(templates);
    }
  }, [searchTemplates, templates]);

  // useEffect(() => {
  //   // subject: filteredTemplateList[selected]?.subject ?? '',
  //   // body: filteredTemplateList[selected]?.body ?? '',
  //   setPreview({
  //     subject: selected?.subject ?? '',
  //     body: selected?.body ?? '',
  //   });
  // }, [filteredTemplateList, selected]);

  const TemplateIndex = () => (
    <TemplateIndexContainer>
      <Box p={2} flexDirection="row" display="flex" justifyContent="space-between">
        <WsTypography
          variant={WsTypoVariants.SUB_TITLE}
          color={WsTypoColors.TERTIARY900}
          bold={true}
        >
          Templates
        </WsTypography>
        <IconButton onClick={handleClose}>
          <Clear />
        </IconButton>
      </Box>
      <Box p={1}>
        <FormProvider {...methods}>
          <SearchBar placeholder="Search" name={'templatesFilter'} />
        </FormProvider>
      </Box>
      <Stack sx={{ maxHeight: '70vh', overflow: 'auto' }}>
        {filteredTemplateList.map((template: T, i: number) => (
          <TemplateItem
            key={i}
            onClick={() => setSelected(template)}
            selected={selected?.id === template?.id}
          >
            <TemplateItemText
              selected={selected?.id === template?.id}
              primary={template.name ?? ''}
              secondary={`(${template.createdBy ?? ''})`}
              primaryTypographyProps={{ style: { fontWeight: 700, whiteSpace: 'normal' } }}
            />
          </TemplateItem>
        ))}
      </Stack>
    </TemplateIndexContainer>
  );

  return (
    <>
      <Grid container borderRadius={2} boxShadow={2} m={2} width={'50vw'}>
        <Grid item xs={12}>
          {TemplateIndex()}
        </Grid>
        <Grid
          direction="row"
          display="flex"
          gap={2}
          p={2}
          item
          style={{ position: 'fixed', bottom: '0', right: '0' }}
        >
          <WsButton size="large" variant="outlined" onClick={handleClose} startIcon={<Cancel />}>
            Cancel
          </WsButton>
          <WsButton size="large" onClick={importTemplate}>
            Import Template
          </WsButton>
        </Grid>
      </Grid>
    </>
  );
};

export default TemplateListing;
